import { KPIData } from '@/types';
import { Dashboard } from '@/components/pages/Dashboard';
import { Tenants } from '@/components/pages/Tenants';
import { Users } from '@/components/pages/Users';
import { QueueManager } from '@/components/pages/QueueManager';
import { Customers } from '@/components/pages/Customers';
import { Messaging } from '@/components/pages/Messaging';
import { QueueAI } from '@/components/pages/QueueAI';
import { Reports } from '@/components/pages/Reports';
import { SettingsImproved as Settings } from '@/components/pages/SettingsImproved';
import { SystemTests } from '@/components/pages/SystemTests';
import SampleDataGenerator from '@/components/pages/SampleDataGenerator';
import { SystemStatus } from '@/components/pages/SystemStatus';
import { SmsCountrySettings } from '@/components/pages/SmsCountrySettings';
import { Help } from '@/components/pages/Help';
import Billing from '@/components/pages/Billing';
import { useAuth } from '@/hooks/useApi';
import { useTenantContext } from '@/contexts/TenantContext';

interface MainContentProps {
  activeTab: string;
  selectedTenant: string;
  userRole: 'super_admin' | 'tenant_admin' | 'tenant_manager' | 'viewer';
  kpiData: KPIData;
  onTabChange?: (tab: string) => void;
}





export function MainContent({ activeTab, userRole, onTabChange }: MainContentProps) {
  const { isSuperAdmin, user } = useAuth();
  const { selectedTenantId } = useTenantContext();
  const activeTenantId = isSuperAdmin ? selectedTenantId : user?.tenant_from_group;
  

  
  return (
    <main className="flex-1 overflow-auto p-3 sm:p-4 md:p-6">
          {activeTab === 'dashboard' && (
            <Dashboard key={activeTenantId} onTabChange={onTabChange} />
          )}
          
          {activeTab === 'tenants' && userRole === 'super_admin' && (
            <Tenants key={activeTenantId} />
          )}
          
          {activeTab === 'users' && (
            <Users key={activeTenantId} />
          )}
          
          {activeTab === 'queue-manager' && (
            <QueueManager key={`qm-${activeTenantId}`} />
          )}
          
          {activeTab === 'customers' && (
            <Customers key={activeTenantId} />
          )}
          
          {activeTab === 'messaging' && (
            <Messaging key={activeTenantId} />
          )}
          
          {activeTab === 'queueai' && (
            <QueueAI key={activeTenantId} />
          )}
          
          {activeTab === 'reports' && (
            <Reports key={activeTenantId} />
          )}
          
          {activeTab === 'billing' && userRole === 'tenant_admin' && (
            <Billing key={activeTenantId} />
          )}
          
          {activeTab === 'settings' && (
            <Settings key={activeTenantId} />
          )}
          
          {activeTab === 'system-tests' && userRole === 'super_admin' && (
            <SystemTests key={activeTenantId} />
          )}
          
          {activeTab === 'sample-data-generator' && userRole === 'super_admin' && (
            <SampleDataGenerator key={activeTenantId} />
          )}
          
          {activeTab === 'system-status' && userRole === 'super_admin' && (
            <SystemStatus key={activeTenantId} />
          )}

          {activeTab === 'sms-countries' && userRole === 'super_admin' && (
            <SmsCountrySettings key="sms-countries" />
          )}

          {activeTab === 'help' && (
            <Help key={activeTenantId} />
          )}
    </main>
  );
}